import { Component, inject, Input } from '@angular/core';
import { NgxBadgeModule } from '@digipay/ngx-badge';
import { UserInfoModel } from '../../models/user-info.model';

@Component({
  selector: 'app-user-info-card',
  standalone: true,
  imports: [NgxBadgeModule],
  templateUrl: './user-info-card.component.html',
  styleUrl: './user-info-card.component.scss',
})
export class UserInfoCardComponent {
  @Input() user: UserInfoModel;

  getUserSejamInfo() {
    switch (this.user?.isSejami) {
      case true:
        return 'سجامی';
      case false:
        return 'فاقد سجام';
      default:
        return 'سجام نامشخص';
    }
  }
}
